import { render } from "./FilterTabs.vue?vue&type=template&id=77267e5d&scoped=true"
import script from "./FilterTabs.vue?vue&type=script&lang=js"
export * from "./FilterTabs.vue?vue&type=script&lang=js"

import "./FilterTabs.vue?vue&type=style&index=0&id=77267e5d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-77267e5d"

export default script